export function resolveEmail(identifier: string, defaultDomain: string): string {
  const v = identifier.trim().toLowerCase();
  if (!v) throw new Error('Enter your username or email.');
  if (v.includes('@')) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) throw new Error('Enter a valid email address.');
    return v;
  }
  if (!/^[a-z0-9._-]{2,64}$/.test(v)) throw new Error('Usernames may contain letters, numbers, dots, dashes and underscores.');
  return `${v}@${defaultDomain}`;
}
